import styled from 'styled-components'
import { colors } from 'app-v2/design-systems/theme'
import { SPACING } from 'app-v2/design-tokens'

export const StyledCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${SPACING.XXL};
    max-width: 400px;
`

export const StyledLine = styled.div`
    border: 1px solid ${colors.neutralBorder};
    width: 100%;
`

export const StyledRestaurantInfoContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`

export const StyledInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
`
